'use client';

import { Col, Heading, Paragraph, IconCard } from '@swordhealth/ui-corporate';
import { CustomContainer, Content, Wrapper, StyledCard, StyledContentGrid } from './styles';
import { MarkdownRichText } from '@/app/components/shared';
import { useMemo, useState } from 'react';
import PersonalDetailsForm from './PersonalDetailsForm/PersonalDetailsForm';
import SuccessStep from './SuccessStep/SuccessStep';

const RegisterForm = ({ content, userName }) => {
  const [formData, setFormData] = useState(null);
  const [step, setStep] = useState(0);

  const STEPS = useMemo(
    () => [
      <PersonalDetailsForm
        setFormData={setFormData}
        key="personal-details-form"
        name={userName}
        buttonLabel={content?.formIntro?.buttonLabel}
        setStep={setStep}
      />,
      <SuccessStep
        formData={formData}
        content={content?.successStep}
        key="register-form-success"
      />,
    ],
    [content?.formIntro?.buttonLabel, content?.successStep, formData, userName],
  );

  return (
    <>
      <Wrapper id="register-form">
        <CustomContainer>
          <Col lg={5} md={12}>
            <Content>
              <Heading as="h1" size="3xl">
                <MarkdownRichText elements={['b', 'strong', 'i']}>
                  {content?.formIntro?.formTitle}
                </MarkdownRichText>
              </Heading>
              <Paragraph>{content?.formIntro?.formDescription}</Paragraph>
            </Content>

            <StyledContentGrid columnCount={1} layout="default" xAlign="left">
              {content?.successPoints?.map((item, index) => (
                <IconCard
                  key={`item.description${index}`}
                  background={false}
                  description={<MarkdownRichText>{item?.label}</MarkdownRichText>}
                  icon="circle-check-through-1px"
                  variant="iconLeft"
                />
              ))}
            </StyledContentGrid>
          </Col>

          <Col lg={6} md={6} sm={6}>
            <StyledCard hasBackground>{STEPS[step]}</StyledCard>
          </Col>
        </CustomContainer>
      </Wrapper>
    </>
  );
};

RegisterForm.defaultConfig = {
  rounded: false,
  colored: false,
  spaceBottom: true,
  spaceTop: true,
  marginBottom: false,
};

export default RegisterForm;
